import { FeatureDataVisualizationInterface } from "src/modules/types";

export class GetFeatureDataVisualization {
  static readonly type = '[Feature]  data visualization';

  constructor(public payload: FeatureDataVisualizationInterface) {
  }
}
